import { render } from "./MMEditCouncil.vue?vue&type=template&id=3f752eca"
import script from "./MMEditCouncil.vue?vue&type=script&lang=js"
export * from "./MMEditCouncil.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__